import { useEffect, useState } from "react";
import { selectIsDarkMode } from "@shared/slices/common.slice";
import { localStorageService } from "utils/localStorageService";
import { useDispatch, useSelector } from "react-redux";
import { useMedia } from "react-use";
import { IS_WEB_VIEW } from "common/constants.ts";
import { sharedLib } from "@shared/services/shared.service.ts";

const useDarkMode = () => {
  const dispatch = useDispatch();
  const isDarkMode = useSelector(selectIsDarkMode);
  const userPrefersDarkMode = useMedia(`(prefers-color-scheme: dark)`, true);
  const [initialized, setInitialized] = useState(false);

  const setIsDarkMode = (isDarkMode: boolean) => {
    window.isDarkMode = isDarkMode;
    dispatch(sharedLib.slices.common.actions.setIsDarkMode(isDarkMode));
  };

  // This effect handles logout, which causes the state to reset and not correctly reload the isDarkMode flag
  // from localStorage
  useEffect(() => {
    let localStorageIsDarkMode = localStorageService.getIsDarkMode();
    if (!initialized && IS_WEB_VIEW) {
      localStorageIsDarkMode = !!window.isDarkMode;
    }
    if (localStorageIsDarkMode === undefined) {
      setIsDarkMode(userPrefersDarkMode);
    } else if (isDarkMode !== localStorageIsDarkMode) {
      setIsDarkMode(localStorageIsDarkMode);
    }
    if (!initialized) setInitialized(true);
  }, [isDarkMode]);
};

export default useDarkMode;
